// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"SaveSearch__contentWrapper__3DGGn","button":"SaveSearch__button__2wNKZ"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/SaveSearch/SaveSearch.scss
// module id = 3058
// module chunks = 4